import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { GetProvizyonRequest, SapProvizyonGroupedResponseModel } from '../models'

export class GetPKPopupApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'VodafoneReports/VodafonePKPopup',
      requesterInfo,
    })
  }

  public async getPK(): Promise<string> {
    return await this.getAsync<string>()
  }
}
